import { ComponentProps } from 'react';
import { COLOR_SCHEME_DARK } from '@namespace/helpers';
import { useColorScheme, useGetThemeImages } from '@namespace/themes';
import { ImagesMap, imagesMap } from './images';

// TODO: remove comment when prettier will be updated

type RemoveImagePrefix<T> = T extends `images/${infer Name}` ? Name : T;
type MergedImages = Record<string, string>;

interface Props extends ComponentProps<'img'> {
  name: RemoveImagePrefix<keyof ImagesMap> | (string & NonNullable<unknown>);
  alt?: string;
}

export const Image = ({ name, alt = '', ...rest }: Props) => {
  const {
    colorScheme: { selectedColorMode }
  } = useColorScheme();

  const themesImages = useGetThemeImages();
  const mergedImages: MergedImages = { ...imagesMap, ...themesImages };

  const fullName = `images/${name}`;
  const path =
    selectedColorMode === COLOR_SCHEME_DARK
      ? mergedImages[`${fullName}_dark`] || mergedImages[fullName]
      : mergedImages[fullName] || mergedImages[`${fullName}_dark`];

  if (!path) {
    return null;
  }

  return <img src={path} key={path} alt={alt} {...rest} />;
};
